import { useCallback, useEffect, useState } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import {
	fetchEditionAwarenessPillDismissed,
	setEditionAwarenessPillDismissed,
} from '../../utils/index.tsx';

export const useIsEditionAwarenessPillDismissed = () => {
	const [hasFetched, setHasFetched] = useState(false);
	const [isDismissed, setIsDismissed] = useState(true);

	useEffect(() => {
		if (fg('edition_awareness_upsell_jira_ab_fg')) {
			fetchEditionAwarenessPillDismissed().then((result) => {
				// if result is undefined, it means the call failed and we can't be certain if the user dismissed the pill or not
				if (result !== undefined) {
					setIsDismissed(!!result);
					setHasFetched(true);
				}
			});
		}
	}, []);

	const handleDismiss = useCallback(() => {
		if (fg('edition_awareness_upsell_jira_ab_fg')) {
			setIsDismissed(true);
			setEditionAwarenessPillDismissed(true);
		}
	}, []);

	return { hasFetched, isDismissed, handleDismiss };
};
